export default __webpack_public_path__ + "static/media/movingTruck1.105c6094.gif";